/** Access Level form info banner — staff ⊆ own grants; Give/Take not from View. */
export const ACCESS_LEVEL_BANNER =
  'Menu → Access Role → actions for this console. Staff can only assign grants they themselves hold. Give / Take is its own grant — not implied by View.'

/**
 * Lab Access Level create: final login = `ownerUsername.suffix`.
 * Idempotent when the typed value already includes the owner prefix.
 */
export function labPrefixedStaffUsername(ownerUsername: string, rawSuffix: string): string {
  const owner = ownerUsername.trim().toLowerCase()
  const raw = rawSuffix.trim().toLowerCase().replace(/\s/g, '')
  if (!owner || !raw) return ''
  const prefix = owner + '.'
  return raw.startsWith(prefix) ? raw : prefix + raw
}

/** Create/update client-side checks before calling Agent-API. */
export function staffUserFormError(opts: {
  isNew: boolean
  username: string
  password: string
  confirm: string
  ownerUsername?: string
}): string | null {
  if (opts.isNew) {
    if (!opts.username.trim()) return 'Username required'
    const owner = (opts.ownerUsername ?? '').trim()
    if (owner) {
      const full = labPrefixedStaffUsername(owner, opts.username)
      if (!full || full.length < 3 || full.length > 32) {
        return 'Full username (owner.suffix) must be 3–32 characters'
      }
    }
    if (!opts.password || opts.password.length < 8) {
      return 'Password must be at least 8 characters'
    }
    if (opts.password !== opts.confirm) return 'Passwords do not match'
    return null
  }
  if (opts.password) {
    if (opts.password.length < 8) return 'Password must be at least 8 characters'
    if (opts.password !== opts.confirm) return 'Passwords do not match'
  }
  return null
}

/** Toggle a single grant code (same code may appear under multiple Access Roles). */
export function toggleStaffGrant(prev: string[], code: string, on: boolean): string[] {
  const next = new Set(prev)
  if (on) next.add(code)
  else next.delete(code)
  return [...next]
}
